import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiManagerService } from '../api-manager/api.maganer.service';
import { environment } from 'src/environments/environment';
import { UserService } from '../user-service/user.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  loggedIn$ = new BehaviorSubject(false);
  lid: number = 214601;
  lidSub= new Subject<number>();
  privateProfile$:any;

  constructor(
    private httpClient: HttpClient, 
    private api: ApiManagerService,
    private userServive:UserService
  ) {
    this.isLoggedIn() ? this.loggedIn$.next(true) : this.loggedIn$.next(false);
  }

  getToken() {
    return localStorage.getItem('token') || '';
  }

  isLoggedIn() {
    return localStorage.getItem('token') || null;
  }

  update() {
    this.isLoggedIn() ? this.loggedIn$.next(true) : this.loggedIn$.next(false);
  }

  getLidByToken() {
    return new Promise<any>(async (resolve, reject) => {
        let isLoged = await this.isLoggedIn();
        console.log('isLoged',isLoged);
        if (isLoged) {
            this.requestLidByToken().then(lid =>{this.lid = lid; resolve(lid)});
        } else {
            resolve('214601');
        }
    });
  }
  
  //new from keycloak
  async requestLidByToken(): Promise<any> {
    let url = `${environment.spooortsBa2Api}`
    return new Promise<any>((resolve, reject) => {
      let token = this.getToken()
      let lid:any
      this.privateProfile$ = this.userServive.getPrivateProfile(token).subscribe((data:any) => {
        console.log('getPrivateProfile', data)
        lid = data?.id || 214601;
        this.lid = lid
        resolve(lid)
      });
    })
  };

  login(loginForm:{password:string, email:string}): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });

    const options = {
      headers,
      params: loginForm,
      responseType: 'text' as 'json' 
    }
    return this.httpClient.post(`${environment.loginApi}keycloak/login?`, null, options,
      ).pipe(
      tap((response: any) => {
        if (response) {
          localStorage.setItem('token', response);
          parent.postMessage("token=" + response, "*");
          this.loggedIn$.next(true);
          this.getLidByToken().then(lid=>{
            this.lidSub.next(lid);
          })
        }
      })
    );
  }

  register(loginForm: {password:string, email:string}): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });

    let options = {
      headers: headers,
      responseType: 'text' as 'json' 
    }
    return this.httpClient.post(`${environment.loginApi}keycloak/`+ `register?email=${loginForm.email}&password=${loginForm.password}`, null, options).pipe(
      tap((response: any) => {
        console.log('registr res', response)
        if (response) {
          try {
            return JSON.parse(response);
          } catch {
            return response;
          }
        }
      })
    );
  }

  logout(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.isLoggedIn()) {
        localStorage.removeItem('token');
        parent.postMessage("token=" + '', "*");
        this.loggedIn$.next(false);
        resolve(null);
        this.lidSub.next(214601);
        // this.lid = 214601;
      }
    });
  }
  removeAccount(token:string){
    let headers = new HttpHeaders({
      'Content-type': 'application/json'
    })
    let options={
      headers:headers
    }
    return this.httpClient.post(`${environment.loginApi}keycloak/user/delete/${token}`, null, options).subscribe(
      result => console.log(result)
    );
    
	}
  signInWithSocial(socialType:string, appUrl:string='https://designeriframe.se2.tech/'){
    return this.httpClient.get(`${environment.loginApi}keycloak/authorization/`+ `${socialType}?redirect_uri=${appUrl}oauth/callback`,
       { responseType: 'text' as 'json' }
    ).pipe(
      tap((responce)=>{
        return responce
    })
   )
  }
  requestToken(appUrl:string='https://designeriframe.se2.tech/', state:string, code:string){
    return this.httpClient.get(`${environment.loginApi}oauth/callback?session_state=${state}&code=${code}&redirect_uri=${appUrl}oauth/callback`,
      { responseType: 'text' as 'json' }
    ).pipe(
      tap((res:any)=>{
        console.log('res token', res);
        localStorage.setItem('token', res);
        parent.postMessage("token=" + res, "*");
        this.loggedIn$.next(true);
        this.getLidByToken().then(lid=>{
          this.lidSub.next(lid);
        })
        return res
      })
    )
  }
}
